import { ICompleteTransactionArgs } from "@smeetz/cert-common/src/lib/interfaces/transaction.types";

export interface ITransaction {
  bookingUuid: string;
  uuid: string; // uuid version 4
  seqId: number;
  groupId: number | null;
  cashfloatUuid: string;
  cashfloatSeqId: number | null;
  receiptNumber: number;
  posRegisterId: string; // fiskaly cash register id on pos_device table
  createdAtTimestamp: number;
  qrcode: string | null;
  signature: string | null;
  completeTransaction: ICompleteTransactionArgs | null;
  closingTransaction: string | null;
  completedAt?: string;
}

export interface IUntypedTransaction {
  uuid: string;
  cashfloatUuid: string;
  bookingUuid: string;
  createdAtTimestamp: number;
  transaction: any;
}

export interface IDEFiskalyVATDefinition {
  vat_definition_export_id: number;
  percentage: number;
  description: string;
}

export interface ICounter {
  id: number; // 123
  groupId: number; // 12345
  reference: string; // "BO" or "Pabc" or ...
  value: number; // 123
  valueReset: number; // value before last reset, defaults to 0
  resetAt: string; // ISO Date: 2025-04-29T10:00:00.000Z
  status: CounterStatus;
  createdAt: string; // ISO Date: 2025-04-29T09:00:00.000Z
  updatedAt: string; // ISO Date: 2025-04-29T11:00:00.000Z
  formattedValue: string; // PXXX-000123

  isCopy?: boolean; // Needed only in case of user re-printing the same receipt again and again within the same orderSession
  isReceiptPrinted?: boolean; // To know if the receipt has already been printed or not yet
}

export enum CounterStatus {
  Active = 1,
  Deleted = 4,
}
